import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { auth, dbAccounts } from "../../../../backend/firebaseConfig";

const COLLECTION_NAME = "MonthlyCommissionStatementPasswords";
const passwordsRef = collection(dbAccounts, COLLECTION_NAME);

const clean = (value) => String(value ?? "").trim();

export const statementPasswordKey = (entryType, entityId) =>
  `${clean(entryType).toLowerCase()}:${clean(entityId).toLowerCase()}`;

const statementPasswordDocumentId = (entryType, entityId) =>
  encodeURIComponent(statementPasswordKey(entryType, entityId));

export const subscribeStatementPasswords = (onData, onError) =>
  onSnapshot(
    passwordsRef,
    (snapshot) => {
      const values = {};
      snapshot.docs.forEach((passwordDocument) => {
        const data = passwordDocument.data() || {};
        const key = statementPasswordKey(data.entryType, data.entityId);
        if (!key.endsWith(":")) {
          values[key] = String(data.statementPassword || "").replace(/\s+/g, "");
        }
      });
      onData(values);
    },
    onError,
  );

export const saveStatementPassword = async ({
  entryType,
  entityId,
  displayName,
  statementPassword,
}) => {
  const type = clean(entryType).toLowerCase();
  const id = clean(entityId);
  if (!type || !id) throw new Error("The statement record could not be identified.");

  const password = String(statementPassword || "").replace(/\s+/g, "");
  const reference = doc(passwordsRef, statementPasswordDocumentId(type, id));
  if (!password) {
    await deleteDoc(reference);
    return;
  }

  await setDoc(reference, {
    entryType: type,
    entityId: id,
    displayName: clean(displayName),
    statementPassword: password,
    updatedAt: serverTimestamp(),
    updatedBy: {
      uid: auth.currentUser?.uid || "",
      email: auth.currentUser?.email || "",
      name: auth.currentUser?.displayName || auth.currentUser?.email || "",
    },
  }, { merge: true });
};
